import _ from 'lodash';

const NORMALMARKET = 500;
const MAINBONUSMARKET = 600;
const BONUSMARKET = 700;
const MAINPLUSBONUSMARKET = 800;

export const generateCalculationsPayload = (numbers, bankers, market, eventCode, stake, numbersToPredictCount, filteredBonus=[]) => {
  const payload = {
    line: 1,
    eventCode,
    marketOutcomeCode: market.outcomes[0].code,
    odds: market.outcomes[0].value,
    marketCode: market.code,
    stake,
    isBanker: false,
    productType: 4
  };

  if (market.typeCode === NORMALMARKET || market.typeCode === MAINBONUSMARKET){
    payload.prediction = {
      rankedNumbers: [
        {
          numbers: bankers
        }
      ],
      anyNumbers: numbers,
      numbersToPredictCount,
      inOrder: false
    };
  } else if (market.typeCode === BONUSMARKET) {
    payload.prediction = {
      rankedNumbers: [
        {
          bonus: numbers
        }
      ],
      anyNumbers: bankers,
      bonusToPredictCount: numbersToPredictCount,
      inOrder: false
    };
  } else if (market.typeCode === MAINPLUSBONUSMARKET){
    const bonusToPredictCount = market.specifiers[1].value;
    const numbersToPredictCount = market.specifiers[0].value;
    const bonusNumbers = _.map(filteredBonus, (bonus) => bonus.number);

    payload.prediction = {
      rankedNumbers: [
        {
          numbers: _.uniq(numbers)
        },
        {
          bonus: bonusNumbers
        }
      ],
      anyNumbers: bankers,
      bonusToPredictCount,
      numbersToPredictCount,
      inOrder: false
    };
  }

  return payload;
};
